
export default function SpecificationsSection() {
  return (
    <section id="specifications" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">建案規格與價格</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            精心規劃的小坪數住宅設計，結合現代生活需求與投資價值。
          </p>
        </div>

        {/* 戶型模擬圖 */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-8">戶型設計</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-lg p-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/6a7748c048b1fdd8a2b5c9ba97b459da.jpg"
                alt="小坪數客廳設計"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h4 className="text-lg font-bold text-gray-900 mb-2">客廳空間</h4>
              <p className="text-gray-600 text-sm">開放式設計，採用無印良品風格，空間利用最大化</p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <img 
                src="https://readdy.ai/api/search-image?query=Compact%20Japanese%20bedroom%20design%20small%20space%2010-20%20ping%2C%20muji%20style%20bedroom%2C%20low%20ceiling%20height%2C%20natural%20wood%20bed%20frame%2C%20white%20bedding%2C%20simple%20furniture%2C%20clean%20lines%2C%20peaceful%20atmosphere%2C%20natural%20materials%2C%20zen%20interior%2C%20soft%20lighting%2C%20neutral%20colors%2C%20space-efficient%20design&width=400&height=300&seq=compact-bedroom&orientation=landscape"
                alt="小坪數臥室設計"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h4 className="text-lg font-bold text-gray-900 mb-2">臥室空間</h4>
              <p className="text-gray-600 text-sm">溫馨舒適的休息空間，合理天花板高度設計</p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <img 
                src="https://readdy.ai/api/search-image?query=Compact%20Japanese%20kitchen%20design%20small%20apartment%2010-20%20ping%2C%20muji%20style%20kitchen%2C%20space-saving%20design%2C%20natural%20wood%20cabinets%2C%20white%20countertops%2C%20simple%20clean%20design%2C%20functional%20layout%2C%20natural%20lighting%2C%20zen%20aesthetic%2C%20modern%20appliances%2C%20neutral%20colors%2C%20efficient%20storage&width=400&height=300&seq=compact-kitchen&orientation=landscape"
                alt="小坪數廚房設計"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h4 className="text-lg font-bold text-gray-900 mb-2">廚房空間</h4>
              <p className="text-gray-600 text-sm">簡潔實用的廚房設計，小空間大機能</p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <img 
                src="https://readdy.ai/api/search-image?query=Small%20Japanese%20apartment%20balcony%20design%2010-20%20ping%2C%20muji%20style%20compact%20outdoor%20space%2C%20natural%20wood%20decking%2C%20simple%20furniture%2C%20plants%2C%20ocean%20view%2C%20relaxing%20atmosphere%2C%20clean%20lines%2C%20neutral%20colors%2C%20peaceful%20outdoor%20living%2C%20tropical%20setting%2C%20space-efficient%20design&width=400&height=300&seq=compact-balcony&orientation=landscape"
                alt="小坪數陽台設計"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h4 className="text-lg font-bold text-gray-900 mb-2">陽台空間</h4>
              <p className="text-gray-600 text-sm">享受石垣島美景的私人戶外空間</p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <img 
                src="https://readdy.ai/api/search-image?query=Compact%20Japanese%20bathroom%20design%20small%20apartment%2010-20%20ping%2C%20muji%20style%20bathroom%2C%20space-efficient%20design%2C%20natural%20materials%2C%20clean%20white%20tiles%2C%20wooden%20accents%2C%20simple%20fixtures%2C%20zen%20atmosphere%2C%20natural%20lighting%2C%20spa-like%20feeling%2C%20modern%20minimalist%20design&width=400&height=300&seq=compact-bathroom&orientation=landscape"
                alt="小坪數衛浴設計"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h4 className="text-lg font-bold text-gray-900 mb-2">衛浴空間</h4>
              <p className="text-gray-600 text-sm">如溫泉般的舒適衛浴設計，空間精巧實用</p>
            </div>
          </div>
          <p className="text-sm text-gray-500 text-center mt-6">
            ※ 裝潢模擬為風格示意圖，依設計規劃討論後優化調整
          </p>
        </div>
        
        {/* 總戶數資訊 */}
        <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-lg p-8 mb-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">總戶數規劃</h3>
          <div className="text-center mb-6">
            <p className="text-lg text-gray-700">若以10坪/戶並計入挑空及虛空間計算</p>
            <p className="text-xl font-bold text-teal-600 mt-2">總戶數 4615/11=<span className="text-3xl text-orange-500">419</span>戶</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg p-6 text-center shadow-sm">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">低樓層（2F～5F）</h4>
              <p className="text-gray-600 mb-2">≈35%</p>
              <p className="text-2xl font-bold text-orange-500">約147戶</p>
            </div>
            <div className="bg-white rounded-lg p-6 text-center shadow-sm">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">中樓層（6F～11F）</h4>
              <p className="text-gray-600 mb-2">≈40%</p>
              <p className="text-2xl font-bold text-orange-500">約168戶</p>
            </div>
            <div className="bg-white rounded-lg p-6 text-center shadow-sm">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">高樓層（12F～14F）</h4>
              <p className="text-gray-600 mb-2">≈25%</p>
              <p className="text-2xl font-bold text-orange-500">約104戶</p>
            </div>
          </div>
          <p className="text-sm text-gray-500 text-center mt-4">
            （此為計算概估，未來部分房型可能調整大小數量）
          </p>
        </div>

        {/* 價格資訊 */}
        <div className="bg-gradient-to-r from-orange-50 to-yellow-50 rounded-lg p-8 mb-12">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-6">銷售金額預估</h3>
          <div className="text-center">
            <p className="text-3xl font-bold text-orange-500 mb-2">
              平均35,000,000日圓（三千五百萬日圓）/戶
            </p>
            <p className="text-lg text-gray-600">約合新台幣 700-800 萬元/戶</p>
          </div>
        </div>

        {/* 付款方式 */}
        <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-lg p-8">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-8">付款方式</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-green-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">預付頭款</h4>
              <p className="text-3xl font-bold text-green-600 mb-2">2萬美金</p>
              <p className="text-gray-600">約合新台幣 60-65 萬元</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bank-line text-teal-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">受託保管銀行</h4>
              <p className="text-lg font-semibold text-teal-600 mb-2">中國信託銀行</p>
              <p className="text-gray-600">專屬信託帳戶安全保管</p>
            </div>
          </div>
          <div className="mt-8 p-6 bg-white rounded-lg border-l-4 border-blue-500">
            <div className="flex items-start space-x-3">
              <i className="ri-information-line text-blue-500 text-lg mt-1"></i>
              <div>
                <p className="text-gray-700">
                  <strong>安全保障：</strong>所有預付款項均由中國信託銀行專屬信託帳戶保管，確保資金安全，讓您安心投資。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
